import { IOrderGroupRepository } from '@/coreInfrastructureModule/interfaces/IOrderGroupRepository';
import { IOrderGroup } from '../../coreDomainsModule/entities/IOrderGroup';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { UpdateOrderGroupAdapter } from '../adapters/updateOrderGroupAdapter';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 発注グループを編集するUseCase
 */
export class UpdateOrderGroupUseCase {
  private repository: IOrderGroupRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderGroupRepository) {
    this.repository = repository;
  }

  /**
   * 発注グループを編集する
   * @param orderGroupId - 変更対象の発注グループID
   * @param editedOrderGroup - 変更内容
   */
  public async execute(orderGroupId: string, editedOrderGroup: IOrderGroup): Promise<INetworkResult<number | undefined, IError>> {
    try {
      const request = UpdateOrderGroupAdapter.adapt(editedOrderGroup);
      const response = await this.repository.updateOrderGroup(orderGroupId, request);
      switch (response.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: response.status.data.orderUpdateAt,
            },
          };
        case 'error':
          return {
            status: {
              type: 'error',
              error: response.status.error,
            },
          };
        default:
          throw new Error();
      }
    } catch (e) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: -1,
            code: 'unknown',
            message: '想定外のエラー',
          },
        },
      };
    }
  }
}
